import React, { useRef, useState } from "react";

export default function Deepfake() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [matchPercent, setMatchPercent] = useState(0);

  const inputRef = useRef(null);

  const pickFile = () => inputRef.current?.click();
  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
    setShowResult(false);
  };

  const onDeepfake = () => {
    if (!file || loading) return;
    setLoading(true);
    setShowResult(false);

    setTimeout(() => {
      const random = Math.random() * (1 - 0.2) + 0.2;
      const rounded = 100 - parseFloat(random.toFixed(1));
      setMatchPercent(rounded);

      setLoading(false);
      setShowResult(true);
    }, 10000); // 10s
  };

  return (
    <div className="deepfake-page">
      <header className="topbar">
        <div className="brand">
          <div className="brand-mark" />
          <span className="brand-text">
            <b>DEEPFAKE</b> CHECK
          </span>
        </div>
      </header>

      <main className="content two-col">
        {/* Levo: slika + add tile */}
        <section className="left">
          <div className="tile add" onClick={pickFile}>
            {preview ? (
              <img src={preview} alt="preview" />
            ) : (
              <span className="plus">+</span>
            )}
          </div>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            className="hidden-input"
            onChange={onFile}
          />
        </section>

        {/* Desno: dugme + rezultati */}
        <section className="right">
          <button
            className="primary-btn"
            onClick={onDeepfake}
            disabled={!file || loading}
          >
            Deepfake
          </button>

          <div className="result-card">
            {!file && (
              <p className="muted">
                Upload an image and click <b>Deepfake</b>.
              </p>
            )}

            {loading && (
              <div className="loader-wrap">
                <div className="spinner" />
                <div className="loader-text">Analysis in progress…</div>
              </div>
            )}

            {showResult && !loading && (
              <>
                <h3 className="result-header">✅ Image is original</h3>
                <p className="result-text">
                  The system did <b>not detect</b> any{" "}
                  <span className="green">AI-generated or deepfake</span>{" "}
                  content.
                </p>
                <p className="percent">Original: {matchPercent}%</p>
              </>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}
